import { colors } from '@sweep-io/sweep-design';
import { ActionsMenuAction } from '../actions-menu/ActionsMenu';
import { Delete, NotePencil } from '@sweep-io/sweep-design/dist/icons';
import { Commands } from '../../../types/enums/Common';

export const getActionsMenu = (isDeleteAllowed: boolean, isUpdateAllowed: boolean) => {
  const actionsMenu: ActionsMenuAction<Commands>[] = [
    {
      value: Commands.Edit,
      label: 'Edit',
      actionIcon: <NotePencil />,
      disabled: !isUpdateAllowed,
    },
  ];
  if (isDeleteAllowed) {
    actionsMenu.push({
      value: Commands.Delete,
      label: 'Delete',
      actionIcon: <Delete color={colors.blush[600]} />,
      actionSx: { color: colors.blush[600] },
    });
  }
  return actionsMenu;
};
